<div class="resource-assignments-container">
  <!-- Sub-tabs: Assignments | Resources -->
  <kendo-buttongroup class="section-toggle">
    <button kendoButton [togglable]="true" [selected]="activeTab === 'assignments'" (click)="activeTab = 'assignments'">
      Process Assignments
    </button>
    <button kendoButton [togglable]="true" [selected]="activeTab === 'resources'" (click)="activeTab = 'resources'">
      Resources (Users)
    </button>
  </kendo-buttongroup>

  <!-- ============================================ -->
  <!-- ASSIGNMENTS TAB                              -->
  <!-- ============================================ -->
  <div class="tab-content" *ngIf="activeTab === 'assignments'">
    <div class="split-panel">
      <!-- Left: Assignment list -->
      <div class="list-panel">
        <div class="list-header">
          <h4>Assignments</h4>
          <button kendoButton [themeColor]="'primary'" [size]="'small'" (click)="createNewAssignment()">
            <span class="k-icon k-font-icon k-i-plus"></span> New
          </button>
        </div>
        <div class="list-search">
          <kendo-textbox placeholder="Search assignments..." [clearButton]="true"
            [(ngModel)]="assignmentSearchTerm" (valueChange)="onAssignmentSearch($event)">
          </kendo-textbox>
        </div>
        <kendo-grid [data]="groupedAssignments" [selectable]="true" [height]="500" [loading]="assignmentLoading"
          [group]="assignmentGroups" [groupable]="false"
          (selectionChange)="onAssignmentSelect($event.selectedRows[0]?.dataItem)" class="assignment-grid">
          <kendo-grid-column field="process.name" title="Process" [width]="180" [hidden]="true"></kendo-grid-column>
          <kendo-grid-column field="productLine.name" title="Product Line" [width]="180"></kendo-grid-column>
          <kendo-grid-column field="typeGroup.description" title="Request Type" [width]="250"></kendo-grid-column>
          <kendo-grid-column title="Users" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.resourceAssignments?.length || 0 }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>

      <!-- Right: Assignment detail + assigned resources -->
      <div class="detail-panel">
        <!-- Assignment form -->
        <div class="detail-section" *ngIf="isEditingAssignment">
          <h4>{{ isNewAssignment ? 'New Assignment' : 'Edit Assignment' }}</h4>
          <form [formGroup]="assignmentForm" class="detail-form">
            <div class="form-field">
              <label>Process</label>
              <kendo-dropdownlist formControlName="processId" [data]="processes" textField="name" valueField="id"
                [valuePrimitive]="true" placeholder="Select process">
              </kendo-dropdownlist>
            </div>
            <div class="form-field">
              <label>Product Line</label>
              <kendo-dropdownlist formControlName="productlineId" [data]="productLines" textField="name" valueField="id"
                [valuePrimitive]="true" placeholder="Select product line">
              </kendo-dropdownlist>
            </div>
            <div class="form-actions">
              <button kendoButton [themeColor]="'primary'" (click)="saveAssignment()" [disabled]="assignmentForm.invalid">Save</button>
              <button kendoButton (click)="cancelEditAssignment()">Cancel</button>
            </div>
          </form>
        </div>

        <!-- Assignment detail (read) -->
        <div class="detail-section" *ngIf="selectedAssignment && !isEditingAssignment">
          <div class="detail-header">
            <h4>{{ selectedAssignment.process?.name }} — {{ selectedAssignment.productLine?.name }}</h4>
            <div class="detail-actions">
              <button kendoButton [size]="'small'" (click)="editAssignment()">Edit</button>
              <button kendoButton [size]="'small'" [themeColor]="'error'" (click)="confirmDeleteAssignment()">Delete</button>
            </div>
          </div>

          <!-- Assigned resources sub-grid -->
          <div class="sub-section">
            <div class="sub-header">
              <h5>Assigned Resources</h5>
              <button kendoButton [size]="'small'" [themeColor]="'primary'" (click)="openAddResourceDialog()">
                <span class="k-icon k-font-icon k-i-plus"></span> Add Resource
              </button>
            </div>
            <kendo-grid [data]="assignmentResources" [height]="300" class="resource-grid">
              <kendo-grid-column title="User" [width]="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.resource?.user?.displayName || 'Unknown' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Email" [width]="200">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.resource?.user?.email || '-' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="isMain" title="Primary" [width]="80">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <kendo-switch [checked]="dataItem.isMain" (valueChange)="toggleMainResource(dataItem)" [size]="'small'">
                  </kendo-switch>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="" [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <button kendoButton [size]="'small'" [look]="'flat'" [themeColor]="'error'" (click)="confirmRemoveResourceAssignment(dataItem)">
                    <span class="k-icon k-font-icon k-i-trash"></span>
                  </button>
                </ng-template>
              </kendo-grid-column>
              <ng-template kendoGridNoRecordsTemplate>
                <div class="empty-state-small">No resources assigned to this process/product line.</div>
              </ng-template>
            </kendo-grid>
          </div>
        </div>

        <!-- No selection -->
        <div class="detail-section empty-state" *ngIf="!selectedAssignment && !isEditingAssignment">
          <span class="k-icon k-font-icon k-i-arrow-left"></span>
          <p>Select an assignment to view and manage its resources.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- RESOURCES TAB                                -->
  <!-- ============================================ -->
  <div class="tab-content" *ngIf="activeTab === 'resources'">
    <div class="split-panel">
      <!-- Left: Resource list -->
      <div class="list-panel">
        <div class="list-header">
          <h4>Resources</h4>
          <button kendoButton [themeColor]="'primary'" [size]="'small'" (click)="createNewResource()">
            <span class="k-icon k-font-icon k-i-plus"></span> New
          </button>
        </div>
        <div class="list-search">
          <kendo-textbox placeholder="Search resources..." [clearButton]="true"
            [(ngModel)]="resourceSearchTerm" (valueChange)="onResourceSearch($event)">
          </kendo-textbox>
        </div>
        <kendo-grid [data]="filteredResources" [selectable]="true" [height]="500" [loading]="resourceLoading"
          (selectionChange)="onResourceSelect($event.selectedRows[0]?.dataItem)" class="resource-list-grid">
          <kendo-grid-column title="User" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.user?.displayName || 'Unknown' }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Email" [width]="200">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ dataItem.user?.email || '-' }}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="isActive" title="Active" [width]="70">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span [style.color]="dataItem.isActive ? 'green' : 'red'">{{ dataItem.isActive ? 'Yes' : 'No' }}</span>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>

      <!-- Right: Resource detail -->
      <div class="detail-panel">
        <div class="detail-section" *ngIf="isEditingResource">
          <h4>{{ isNewResource ? 'New Resource' : 'Edit Resource' }}</h4>
          <form [formGroup]="resourceForm" class="detail-form">
            <div class="form-field">
              <label>User ID</label>
              <kendo-numerictextbox formControlName="userId" [min]="1" [decimals]="0" [format]="'#'" placeholder="Enter User ID">
              </kendo-numerictextbox>
            </div>
            <div class="form-field">
              <label>Active</label>
              <kendo-switch formControlName="isActive"></kendo-switch>
            </div>
            <div class="form-actions">
              <button kendoButton [themeColor]="'primary'" (click)="saveResource()" [disabled]="resourceForm.invalid">Save</button>
              <button kendoButton (click)="cancelEditResource()">Cancel</button>
            </div>
          </form>
        </div>

        <div class="detail-section" *ngIf="selectedResource && !isEditingResource">
          <div class="detail-header">
            <h4>{{ selectedResource.user?.displayName || 'Resource #' + selectedResource.id }}</h4>
            <div class="detail-actions">
              <button kendoButton [size]="'small'" (click)="editResource()">Edit</button>
              <button kendoButton [size]="'small'" [themeColor]="'error'" (click)="confirmDeleteResource()">Delete</button>
            </div>
          </div>
          <div class="detail-info">
            <p><strong>User ID:</strong> {{ selectedResource.userId }}</p>
            <p><strong>Email:</strong> {{ selectedResource.user?.email || '-' }}</p>
            <p><strong>Active:</strong> {{ selectedResource.isActive ? 'Yes' : 'No' }}</p>
          </div>
        </div>

        <div class="detail-section empty-state" *ngIf="!selectedResource && !isEditingResource">
          <span class="k-icon k-font-icon k-i-arrow-left"></span>
          <p>Select a resource to view details.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================ -->
  <!-- DIALOGS                                      -->
  <!-- ============================================ -->

  <!-- Add Resource to Assignment Dialog -->
  <kendo-dialog *ngIf="showAddResourceDialog" title="Add Resource to Assignment" (close)="showAddResourceDialog = false" [width]="400">
    <div class="dialog-form">
      <div class="form-field">
        <label>Resource</label>
        <kendo-combobox [data]="filteredAvailableResources" textField="user.displayName" valueField="id"
          [valuePrimitive]="true" [(ngModel)]="addResourceId" placeholder="Search for a resource..."
          [filterable]="true" (filterChange)="onAddResourceFilter($event)"
          [virtual]="{ itemHeight: 36 }" [popupSettings]="{ height: 300 }">
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span>{{ dataItem.user?.displayName }}</span>
            <small style="margin-left: 8px; color: #64748b;">{{ dataItem.user?.email }}</small>
          </ng-template>
        </kendo-combobox>
      </div>
      <div class="form-field">
        <label>Primary resource</label>
        <kendo-switch [(ngModel)]="addResourceIsMain"></kendo-switch>
      </div>
    </div>
    <kendo-dialog-actions>
      <button kendoButton (click)="showAddResourceDialog = false">Cancel</button>
      <button kendoButton [themeColor]="'primary'" (click)="addResourceToAssignment()" [disabled]="!addResourceId">Add</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- Delete Assignment Confirmation -->
  <kendo-dialog *ngIf="deleteAssignmentDialogOpen" title="Delete Assignment" (close)="deleteAssignmentDialogOpen = false" [width]="400">
    <p>Are you sure you want to delete this assignment? All resource links will also be removed.</p>
    <kendo-dialog-actions>
      <button kendoButton (click)="deleteAssignmentDialogOpen = false">Cancel</button>
      <button kendoButton [themeColor]="'error'" (click)="deleteAssignment()">Delete</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- Delete Resource Confirmation -->
  <kendo-dialog *ngIf="deleteResourceDialogOpen" title="Delete Resource" (close)="deleteResourceDialogOpen = false" [width]="400">
    <p>Are you sure you want to delete this resource? They will be removed from all assignments.</p>
    <kendo-dialog-actions>
      <button kendoButton (click)="deleteResourceDialogOpen = false">Cancel</button>
      <button kendoButton [themeColor]="'error'" (click)="deleteResource()">Delete</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <!-- Remove Resource from Assignment Confirmation -->
  <kendo-dialog *ngIf="deleteResourceAssignmentDialogOpen" title="Remove Resource" (close)="deleteResourceAssignmentDialogOpen = false" [width]="400">
    <p>Remove {{ selectedResourceAssignment?.resource?.user?.displayName }} from this assignment?</p>
    <kendo-dialog-actions>
      <button kendoButton (click)="deleteResourceAssignmentDialogOpen = false">Cancel</button>
      <button kendoButton [themeColor]="'error'" (click)="removeResourceAssignment()">Remove</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
